import React from 'react';

import LeadCaptureModalBody, { LeadCaptureModalBodyProps } from '../LeadCaptureModalBody';
import ModalHeader, { ModalHeaderProps } from '../common/modalHeader';

export type LeadCaptureProps = ModalHeaderProps & LeadCaptureModalBodyProps;

const LeadCaptureModal = ({
  articleId,
  briefingGuid,
  buttonText,
  disclosure,
  highlight,
  leadType,
  modalType,
  newsletterId,
  offerLink,
  shareGuid,
  subtitle,
  title,
  unlockContent,
}: LeadCaptureProps) => {
  return (
    <div className="flex w-full flex-wrap content-center items-center justify-center px-24 py-72 sm:px-64 sm:py-64 md:justify-between md:px-48 md:pb-80 md:pt-80">
      <ModalHeader
        disclosure={disclosure}
        highlight={highlight}
        modalType={modalType}
        subtitle={subtitle}
        title={title}
      />
      <div className="w-full md:w-[380px]">
        <LeadCaptureModalBody
          articleId={articleId}
          briefingGuid={briefingGuid}
          buttonText={buttonText}
          leadType={leadType}
          newsletterId={newsletterId}
          offerLink={offerLink}
          shareGuid={shareGuid}
          unlockContent={unlockContent}
        />
      </div>
    </div>
  );
};

export default LeadCaptureModal;
